export const getLanguageConfig = (lang: string) => {
    if(lang === 'ru') return require('./ru.json')
    if(lang === 'en') return require('./en.json')
    if(lang === 'pl') return require('./pl.json')
    if(lang === 'ua') return require('./ua.json')
    if(lang === 'sr') return require('./sr.json')

    return require('./ru.json')
}
